





// import React, { useState } from 'react';
// import { BiCheck } from 'react-icons/bi';
// import Naira from '../assets/Images/naira.png';
// import { formatAmount } from '../Utils/formatAmount';
// import usePayment from '../hooks/usePayment';
// import { PAYSTACK_EMAIL } from '../Utils/constant';

// const JobCategory = ({
//   plan_name,
//   plan_price,
//   plan_benefits,
//   categorySelection,
//   setCategorySelection,
//   setPaymentReference,
//   setJobType,
//   close,
// }) => {
//   const newAmount = formatAmount(plan_price);
//   const [paymentDone, setPaymentDone] = useState(false);
//   const email = PAYSTACK_EMAIL;

//   const { PaymentComponent, initiatePayment } = usePayment(
//     email,
//     process.env.REACT_APP_PAYSTACK_PUBLIC_KEY,
//     plan_price,
//     (paymentDetails) => {
//       console.log('Payment successful', paymentDetails);
//       setPaymentDone(true);
//       setCategorySelection(plan_name);
//       setJobType(plan_name);
//       setPaymentReference(paymentDetails);
//     },
//     () => close()
//   );

//   const handleCheck = (selected_plan) => {
//     if (selected_plan) setCategorySelection(selected_plan);
//     close();
//   };

//   return (
//     <div className="relative font-mon flex flex-col items-center justify-start gap-6 w-[300px] h-[650px] border border-gray-200 shadow-lg p-6 rounded-xl bg-white transition-all duration-300 hover:shadow-xl">
//       <button
//         onClick={close}
//         className="absolute top-4 right-4 text-gray-600 hover:text-gray-800 text-2xl font-bold rounded-full w-8 h-8 flex items-center justify-center hover:bg-gray-100 transition-colors duration-300"
//         aria-label="Close modal"
//       >
//         &times;
//       </button>
//       <h2 className="text-3xl text-orange-600 font-bold tracking-wide uppercase">{plan_name}</h2>
//       <div className="flex items-center justify-center gap-2 py-4">
//         <img className="w-6 h-6" src={Naira} alt="Naira symbol" />
//         <h1 className="text-4xl text-gray-800 font-extrabold">{newAmount}</h1>
//         <span className="text-lg text-gray-600 font-medium">/month</span>
//       </div>
//       <hr className="w-full border-t-2 border-gray-300 my-4" />
//       <div className="text-start mb-16 w-full space-y-4">
//         {plan_benefits.map((benefit) => (
//           <div key={benefit} className="flex items-start justify-start gap-3">
//             <BiCheck className="text-green-600 w-6 h-6 mt-1" />
//             <p className="text-gray-700 text-base leading-relaxed">{benefit}</p>
//           </div>
//         ))}
//       </div>
//       {plan_name !== 'Free Plan' ? (
//         <button
//           onClick={initiatePayment}
//           disabled={paymentDone}
//           className={`absolute bottom-6 left-1/2 transform -translate-x-1/2 text-lg font-semibold px-8 py-3 rounded-lg border-2 border-orange-500 ${paymentDone ? 'bg-green-600 text-white' : 'bg-orange-500 text-white'} hover:bg-white hover:text-orange-500 focus:outline-none focus:ring-2 focus:ring-orange-500 transition-colors duration-300 disabled:opacity-75 disabled:cursor-not-allowed`}
//           aria-label={`Initiate payment for ${plan_name}`}
//         >
//           {paymentDone ? (
//             <div className="flex items-center gap-2">
//               <BiCheck className="w-5 h-5" /> <span>Paid</span>
//             </div>
//           ) : (
//             <PaymentComponent />
//           )}
//         </button>
//       ) : (
//         <button
//           onClick={() => handleCheck(plan_name)}
//           className="absolute bottom-6 left-1/2 transform -translate-x-1/2 text-lg font-semibold px-8 py-3 rounded-lg border-2 border-green-600 bg-green-600 text-white hover:bg-white hover:text-green-600 focus:outline-none focus:ring-2 focus:ring-green-600 transition-colors duration-300"
//           aria-label={`Select ${plan_name}`}
//         >
//           {categorySelection === 'Free Plan' ? 'Selected' : 'Select'}
//         </button>
//       )}
//     </div>
//   );
// };

// export default JobCategory;




// JobCategory.js
import React, { useState } from "react";
import { BiCheck } from "react-icons/bi";
import Naira from "../assets/Images/naira.png";
import { formatAmount } from "../Utils/formatAmount";
import axios from "axios";
import { toast } from "sonner";

const JobCategory = ({
  plan_name,
  plan_price,
  plan_benefits,
  categorySelection,
  setCategorySelection,
  setPaymentReference,
  setJobType,
  close,
  loggedinUser,
}) => {
  const newAmount = formatAmount(plan_price);
  const [paymentDone, setPaymentDone] = useState(false);
  const email = loggedinUser?.currentUser?.email || null;
  const token = localStorage.getItem("token")
  console.log(token, "my token")

  const initiatePayment = async () => {
    if (paymentDone) return;
    if (!email) {
      toast.error("User email not found. Please sign in again.");
      return;
    }
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}job/payment`,
        { jobType: plan_name, email },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const { authorization_url, reference } = response.data.data;
      console.log(response.data.data, "my log is here ")
      setPaymentReference(reference);
      setPaymentDone(true);
      setCategorySelection(plan_name);
      setJobType(plan_name);
      toast.success(`Initiating payment for ${plan_name} plan`);
      window.location.href = authorization_url;
    } catch (error) {
      console.error("Error initiating payment:", error.response?.data || error.message);
      toast.error("Failed to initiate payment. Please try again.");
      setPaymentDone(false);
    }
  };

  const handleDraftSelection = () => {
    setCategorySelection(plan_name);
    setJobType("Draft");
    setPaymentReference("N/A");
    toast.success("Draft plan selected");
    close();
  };

  return (
    <div className="relative font-mon flex flex-col items-center justify-start gap-6 w-[300px] h-[650px] border border-gray-200 shadow-lg p-6 rounded-xl bg-white transition-all duration-300 hover:shadow-xl">
      <button
        onClick={close}
        className="absolute top-4 right-4 text-gray-600 hover:text-gray-800 text-2xl font-bold rounded-full w-8 h-8 flex items-center justify-center hover:bg-gray-100 transition-colors duration-300"
        aria-label="Close modal"
      >
        &times;
      </button>
      <h2 className="text-3xl text-green-600 font-bold tracking-wide uppercase">
        {plan_name}
      </h2>
      <div className="flex items-center justify-center gap-2 py-4">
        <img className="w-6 h-6" src={Naira} alt="Naira symbol" />
        <h1 className="text-4xl text-gray-800 font-extrabold">{newAmount}</h1>
        <span className="text-lg text-gray-600 font-medium">
          {plan_name === "Draft" ? "" : "/month"}
        </span>
      </div>
      <hr className="w-full border-t-2 border-gray-300 my-4" />
      <div className="text-start mb-16 w-full space-y-4">
        {plan_benefits.map((benefit) => (
          <div key={benefit} className="flex items-start justify-start gap-3">
            <BiCheck className="text-green-600 w-6 h-6 mt-1" />
            <p className="text-gray-700 text-base leading-relaxed">{benefit}</p>
          </div>
        ))}
      </div>
      {plan_name === "Draft" ? (
        <button
          onClick={handleDraftSelection}
          className={`absolute bottom-6 left-1/2 transform -translate-x-1/2 text-lg font-semibold px-8 py-3 rounded-lg border-2 border-green-600 ${
            categorySelection === "Draft"
              ? "bg-green-600 text-white"
              : "bg-white text-green-600 hover:bg-green-600 hover:text-white"
          } focus:outline-none focus:ring-2 focus:ring-green-600 transition-colors duration-300`}
          aria-label="Select Draft plan"
        >
          {categorySelection === "Draft" ? "Selected" : "Select"}
        </button>
      ) : (
        <button
          onClick={initiatePayment}
          disabled={paymentDone || !email}
          className={`absolute bottom-6 left-1/2 transform -translate-x-1/2 text-lg font-semibold px-8 py-3 rounded-lg border-2 border-green-500 ${
            paymentDone || !email ? "bg-gray-400 text-white cursor-not-allowed" : "bg-green-500 text-white"
          } hover:bg-white hover:text-green-500 focus:outline-none focus:ring-2 focus:ring-green-500 transition-colors duration-300 disabled:opacity-75 disabled:cursor-not-allowed`}
          aria-label={`Initiate payment for ${plan_name}`}
        >
          {paymentDone ? (
            <div className="flex items-center gap-2">
              <BiCheck className="w-5 h-5" /> <span>Paid</span>
            </div>
          ) : (
            "Pay Now"
          )}
        </button>
      )}
    </div>
  );
};

export default JobCategory;











